function getAlertOrBannerIcon(type) {
    switch (type) {
        case 'info':
            return 'info-circle';
        case 'error':
            return 'alert-circle';
        case 'warning':
            return 'alert-triangle';
        case 'success':
            return 'circle-check';
    }
}

export { getAlertOrBannerIcon as g };
